<template>
  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat bg-[#5c5c5e]">
    <div class="w-full">
      <div class="px-5 py-20 flex flex-col items-center max-h-full">
        <img class="max-h-full object-contain hidden md:block" src="@/assets/logo.png"/>
        <img class="max-h-full object-contain block md:hidden " src="@/assets/logo_mobile.png"/>
      </div>
    </div>
  </header>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>